//import warning from 'warning'

"use strict";

exports.__esModule = true;
function deprecate(fn) {
  return fn;
  //return function () {
  //  warning(false, '[history] ' + message)
  //  return fn.apply(this, arguments)
  //}
}

exports["default"] = deprecate;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/history/lib/deprecate.js
// module id = 175
// module chunks = 0 1